import React from 'react';
import { useTranslation } from "react-i18next";
import Styles from "../../../scss/discounts.module.scss"
export function MenuStatus({ enabled }: { enabled: boolean }) {
  const { t } = useTranslation();
  return (
    <span>
      <span className={enabled ? Styles.enabled : Styles.disabled}>{enabled ? t(`manageMenu.manageMenuContainer.active`) : t(`manageMenu.manageMenuContainer.inactive`)}</span>
    </span>
  )
}
